module.exports = __webpack_public_path__ + "img/icon-bell.8318e6cf.svg";